import type { PublicKeys, PublicKeysDto } from './publicKeys.types';

export const parsePublicKeysForUI = (data: PublicKeysDto): PublicKeys => ({
  facebookId: data.FACEBOOK_ID,
  googleRecaptchaSiteKey: data.GOOGLE_RECAPTCHA_SITE_KEY,
  landingPageRecaptchaPublic: data.LANDING_PAGE_RECAPTCHA_PUBLIC,
  googleClientId: data.GOOGLE_CLIENT_ID ?? data.GOOGLE_ID ?? data.GOOGLE_OAUTH2_CLIENT_ID ?? '',
});
